export default __webpack_public_path__ + "static/media/Footpad's Boots of the Swift Return.6481981a.jpg";